import React, { Component } from 'react'
import CurrencyFormat from 'react-currency-format'
import { connect } from 'react-redux'
import { CalculFraisDeNotaire, UpdateIntField } from '../../engine/Rules'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocIntField extends Component {
    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        const styleInput = {}
        let erreur = <div></div>
        if (this.props.validated === false) {
            styleInput.backgroundColor = 'rgb(247 199 199)'
                if (this.props.messageErreur) {
                    erreur = (
                        <div className="erreurTextFormat">
                            {this.props.messageErreur}
                        </div>
                    )
                }
        } else if (this.props.validated === true) {
            styleInput.backgroundColor = 'rgb(230 243 240)'
        }

        var affichageFraisDeNotaire
        if (this.props.informationApport) {
            var frais = 0
            if (this.props.fraisNotaire) {
                frais = this.props.fraisNotaire
            } else {
                frais = CalculFraisDeNotaire(
                    this.props.prixAchat,
                    this.props.prixTerrain,
                    this.props.projetType,
                    true
                )
            }
            affichageFraisDeNotaire = (
                <div className="size11">
                    Le niveau d’apport constitue un atout pour votre dossier. Il
                    doit couvrir à minima les frais de notaire (<b>{frais} €</b>{' '}
                    ).
                </div>
            )
        }

        let premadeContent = (
            <div>
                <div className="labelfield">{this.props.label}</div>
                {affichageFraisDeNotaire}

                <CurrencyFormat
                    style={styleInput}
                    value={this.props.targetDataValue}
                    placeholder={this.props.placeholder}
                    className="field bold-font"
                    thousandSeparator={' '}
                    allowNegative={false}
                    type="tel"
                    decimalSeparator={','}
                    suffix={this.props.symbole}
                    format={this.props.format}
                    mask={this.props.mask}
                    onValueChange={(value) =>
                        UpdateIntField(this.props.linked_data_id, value, this.props.limit)
                    }
                />
                {erreur}
            </div>
        )

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    // standard value + buy price
    if (ownProps.informationApport) {
        return {
            prixAchat: state.answer['prj_montant_achat'],
            prixTerrain: state.answer['prj_montant_terrain'],
            prixConstruction: state.answer['prj_montant_construction'],
            projetType: state.answer['prj_type'],
            targetDataValue: state.answer[ownProps.linked_data_id],
        }
    }

    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
        validated: state.answer[ownProps.linked_data_id + '_validated'],
    }
}

export default connect(mapStateToProps)(BlocIntField)
